<app-page-layout [alertLoading]="alertLoading" [alertSucesso]="alertSucesso" [alertError]="alertError">
  <h1 class="titulo">Edição de endereço</h1>
  <p class="paragrafo mb-4">Edição de endereço já cadastrado</p>

  @if (dadosEndereco) {
    <app-endereco-form
      [formulario]="formulario"
      [consultaCep]="consultaCep"
      [mensagemErro]="mensagemErro">
    </app-endereco-form>
    <div class="col-12 ps-0">
      <div class="row">
        <div class="col-12 col-md-6 text-end">
          <button class="botao-outline" (click)="voltarAbaEnderecos()">FECHAR</button>
        </div>
        <div class="col-12 col-md-6 text-start">
          <button class="botao"
            [ngClass]="{ 'disabled': !formularioChanges || formulario.invalid }"
            [disabled]="!formularioChanges || formulario.invalid"
          (click)="editarEndereco()">SALVAR</button>
        </div>
      </div>
    </div>
  }

  @if (dadosEndereco === null) {
    <div>
      <div class="text-center">
        <output class="spinner-border c-primary">
          <span class="visually-hidden">Consultando dados do endereço ...</span>
        </output>
      </div>
      <p class="legenda-spinner">Consultando dados do endereço ...</p>
    </div>
  }

  @if (dadosEndereco === false) {
    <div class="text-center">
      <img src="/assets/img/erro.png" width="200px" alt="Erro">
      <p class="legenda-erro">Ocorreu um erro na consulta do endereço.</p>
    </div>
  }
</app-page-layout>
